import React, { useRef, useEffect } from 'react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["html", "dangerouslySetInnerHTML"];
function DangerouslySetHtmlContent(_ref) {
  var html = _ref.html,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var divRef = useRef(null);
  var isFirstRender = useRef(true);
  useEffect(function () {
    if (!html || !divRef.current) throw new Error("html prop cant't be null");
    if (!isFirstRender.current) return;
    isFirstRender.current = false;
    var slotHtml = document.createRange().createContextualFragment(html);
    divRef.current.innerHTML = '';
    divRef.current.appendChild(slotHtml);
  }, [html, divRef]);

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: divRef
  }));
}

export default DangerouslySetHtmlContent;
//# sourceMappingURL=index.modern.js.map
